import { BUSINESS_TYPES, type BusinessType } from './catalog.ts'

// The kind of business a visitor came for: the site's business pages link to
// the app with ?type=restaurant, and sign-up starts with that type chosen. It
// is kept on this device because sign-up can take a detour (confirming an
// email) that drops the address.
const KEY = 'ims.signup-type'

const known = (value: string | null): BusinessType | null =>
  BUSINESS_TYPES.find((t) => t.id === value)?.id ?? null

/** Reads ?type= from an address ("?type=restaurant"). */
export function signupTypeFrom(search: string): BusinessType | null {
  return known(new URLSearchParams(search).get('type'))
}

/** The type the visitor arrived with, now or earlier on this device. */
export function signupType(): BusinessType | null {
  if (typeof window === 'undefined') return null
  try {
    const now = signupTypeFrom(window.location.search)
    if (now) {
      window.localStorage.setItem(KEY, now)
      return now
    }
    return known(window.localStorage.getItem(KEY))
  } catch {
    return null
  }
}

export function clearSignupType(): void {
  try {
    window.localStorage.removeItem(KEY)
  } catch {
    // Private mode: nothing was kept.
  }
}

// Remember it as soon as the app loads, before any sign-in detour.
signupType()
